export const validateSubmit = (values) => {
    const errors = {}
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if (!re.test(values.username)) {
        errors.username = "main:email_error"
    }

    if (!values.password) errors.password = "main:required_password"

    return errors
}

export const validatePresence = (values) => {
    const errors = {}

    /* eslint no-underscore-dangle: [0] */
    if (!values.username) errors._error = true

    return errors
}